export default {
  agentInfo: null,
  messages: [],
  sessionId: null,
  isStreaming: false,
  isOpen: false,
  hasChecked: false
};
